import React from 'react';
import './Styles/PricingTabs.scss';
import {ReactComponent as Switch1} from '../../../Assets/Icons/switch1.svg';
import {ReactComponent as Switch2} from '../../../Assets/Icons/switch2.svg';
import { useState } from 'react';
import { Panel1, Panel2 } from './Panel';

const PricingTabs=()=>{
    const [active,setActive] = useState(false);
    function setBtn(){
        setActive(!active);
    }
    return(
        <div className="pricing-tabs">
            <div className="btns">
            <p>Bill Monthly</p>
          <div onClick={setBtn}>
             {active===false ? <Switch2 /> : <Switch1 />}
          </div>
          <p>Bill Yearly</p>

            </div>
           <div>
           {active === false && <Panel1/>}
           {active === true && <Panel2/>}
           </div>
        </div>
    )
};
export default PricingTabs;